module.exports = __webpack_public_path__ + "embrace.6dc5c440.png";